// extracted by mini-css-extract-plugin
export default {"pagination":"Pagination_pagination__p22He","paginationNumbers":"Pagination_paginationNumbers__utpWs"};